import React, { Component } from 'react';
import {
  Button,
  Grid,
  Row,
  Col,
  Form,
  FormControl,
  Modal,
} from 'react-bootstrap';
// import Container from 'react-bootstrap/Container'
import { findDOMNode } from 'react-dom';
import DatePicker from 'react-date-picker';
import { invokeApig } from '../../libs/awsLib';

const couponCategoriesCSInput = require('./CouponCategoriesCS.json');
const couponValuesCSInput = require('./CouponValuesCS.json');

const imageNamePrefixCustomerService = 'CUSTOMER-SERVICE';

// TODO: refactor component to prevent all ESlint errors
/* eslint-disable react/jsx-no-bind, react/no-string-refs, jsx-a11y/control-has-associated-label, no-return-assign, react/no-unknown-property, react/no-find-dom-node, react/no-access-state-in-setstate */

class Coupons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCouponCategory: null,
      selectedCouponValue: null,
      couponCategoriesCS: [],
      couponValuesCS: [],
      currentStartDate: null,
      currentEndDate: null,
      alertModal: {
        mode: false,
        text: '',
      },
      generatedCoupon: {
        couponName: null,
        couponReason: null,
        couponValue: null,
        couponExpiry: null,
      },
    };
    this.handleCurrentStartDateChange =
      this.handleCurrentStartDateChange.bind(this);
    this.handleCurrentEndDateChange =
      this.handleCurrentEndDateChange.bind(this);
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    this.populateValues();
  }

  handleUpdate(e) {
    if (e.target.id === 'coupon-categories-choice') {
      const couponCategoryObj = this.state.couponCategoriesCS.filter(
        (x) => x.displayValue === e.target.value,
      );
      if (
        !(couponCategoryObj === undefined || couponCategoryObj.length === 0)
      ) {
        this.setState({ selectedCouponCategory: couponCategoryObj[0] });
      } else {
        this.setState({ selectedCouponCategory: null });
      }
    } else if (e.target.id === 'coupon-values-choice') {
      const couponValueObj = this.state.couponValuesCS.filter(
        (x) => x.displayValue === e.target.value,
      );
      if (!(couponValueObj === undefined || couponValueObj.length === 0)) {
        this.setState({ selectedCouponValue: couponValueObj[0] });
      } else {
        this.setState({ selectedCouponValue: null });
      }
    }
  }

  handleCurrentEndDateChange(value) {
    this.setState({ currentEndDate: value });
  }

  handleCurrentStartDateChange(value) {
    this.setState({ currentStartDate: value });
  }

  // TODO: investingate if possible rewrite `findDOMNode`, it cause ESlint:react/no-find-dom-node now
  // TODO: rewrite funtion to prevent ESlint:no-shadow
  async generateCoupon() {
    this.disableButton();
    // eslint-disable-next-line react/no-find-dom-node
    const couponCategory = findDOMNode(this.refs.couponCategory).value.trim();

    // eslint-disable-next-line react/no-find-dom-node
    const couponValue = findDOMNode(this.refs.couponValue).value.trim();
    // eslint-disable-next-line no-shadow
    let couponValueObj = function (couponValue) {
      const rObj = {};
      if (couponValue.includes('$')) {
        rObj.type = 'AMOUNT';
        rObj.value = couponValue.replace(/[^\w\s]/gi, '').replace(/\s/g, '');
        return rObj;
      }
      if (couponValue.includes('%')) {
        rObj.type = 'PERCENT';
        rObj.value = couponValue
          .toString()
          .replace(/[^\w\s]/gi, '')
          .replace(/\s/g, '');
        return rObj;
      }
    };
    // couponValueObj = couponValueObj(couponValue);
    // eslint-disable-next-line no-shadow
    let couponCategoryObj = function (couponCategory) {
      const rObj = {};
      rObj.imageNameSuffix = couponCategory
        .replace(/[^\w\s]/gi, '_')
        .replace(/\s/g, '')
        .toUpperCase();
      return rObj;
    };
    // couponCategoryObj = couponCategoryObj(couponCategory);
    // console.log(couponValueObj(couponValue)); console.log();
    couponValueObj = couponValueObj(couponValue);
    couponCategoryObj = couponCategoryObj(couponCategory);
    const requestBody = {
      imageName: `${imageNamePrefixCustomerService}-${couponCategoryObj.imageNameSuffix}`,
      type: couponValueObj.type,
      value: parseInt(couponValueObj.value, 10),
      startDate: this.state.currentStartDate.toISOString(),
      endDate: this.state.currentEndDate.toISOString(),
    };
    console.log(requestBody);

    const alertModal = this.state.alertModal;
    const generatedCoupon = this.state.generatedCoupon;
    let apiResponse;
    try {
      apiResponse = await invokeApig({
        path: '/coupons',
        method: 'POST',
        body: requestBody,
      });
      console.log(apiResponse);

      if (
        'statusCode' in apiResponse &&
        apiResponse.statusCode === '200' &&
        'couponCode' in apiResponse
      ) {
        alertModal.mode = true;
        generatedCoupon.couponName = apiResponse.couponCode;
        generatedCoupon.couponValue = couponValue;
        generatedCoupon.couponReason = couponCategory;
        generatedCoupon.couponExpiry = this.state.currentEndDate
          .toISOString()
          .split('T')[0];
        console.log(generatedCoupon);

        this.setState({ alertModal, generatedCoupon });
      }
    } catch (e) {
      alertModal.mode = true;
      const errorString = JSON.stringify(e);
      const errorObject = JSON.parse(errorString);
      console.log(errorObject);
      if ('response' in errorObject) {
        alertModal.text = errorObject.response.data.message;
      } else {
        alertModal.text =
          'Unable to generate code, Check your internet and your permissions';
      }
      this.setState({
        alertModal,
        selectedCouponCategory: null,
        selectedCouponValue: null,
        currentStartDate: null,
        currentEndDate: null,
      });
    }
  }

  disableButton() {
    document.getElementById('generateCodeButton').disabled = true;
  }

  populateValues() {
    const couponCategoriesCS = couponCategoriesCSInput
      .filter((obj) => typeof obj === 'string')
      .filter((obj) => obj)
      .map((x) => {
        const rObj = {};
        rObj.displayValue = x;
        return rObj;
      });
    let couponValuesCS = couponValuesCSInput
      .filter((obj) => typeof obj === 'string')
      .filter((obj) => obj)
      .map((x) => {
        const rObj = {};
        if (x.includes('$') || x.includes('%')) {
          rObj.displayValue = x;
          return rObj;
        }
        return null;
      });
    couponValuesCS = couponValuesCS.filter((obj) => obj);
    this.setState({ couponCategoriesCS, couponValuesCS });
  }

  resetInputFields() {
    findDOMNode(this.couponGenForm).reset();
    const alertModal = this.state.alertModal;
    alertModal.mode = false;
    alertModal.text = '';
    this.setState({
      alertModal,
      selectedCouponCategory: null,
      selectedCouponValue: null,
      currentStartDate: null,
      currentEndDate: null,
    });
  }

  copyToClipboard() {
    document.getElementById('couponCopy').select();
    document.execCommand('copy');
  }

  render() {
    return (
      <div>
        <style />
        <div id="alertBox">
          <Modal show={this.state.alertModal.mode}>
            <Modal.Header>Customer Service Code</Modal.Header>
            <Modal.Body>
              {this.state.generatedCoupon.couponName &&
              this.state.generatedCoupon.couponReason &&
              this.state.generatedCoupon.couponValue &&
              this.state.generatedCoupon.couponExpiry ? (
                <div className="form-group" id="modalbody">
                  Your&nbsp;single&nbsp;use&nbsp;code&nbsp;for&nbsp;
                  <b>{this.state.generatedCoupon.couponReason}</b>
                  &nbsp;with a value of&nbsp;
                  <b>{this.state.generatedCoupon.couponValue}</b>
                  &nbsp;expiring&nbsp;
                  <b>{this.state.generatedCoupon.couponExpiry}</b>
                  &nbsp;is:
                  <br />
                  <br />
                  <div align="center">
                    <FormControl
                      componentClass="input"
                      id="couponCopy"
                      type="text"
                      defaultValue={this.state.generatedCoupon.couponName}
                      style={{
                        textAlign: 'center',
                      }}
                      readOnly="readOnly"
                    />
                    <Button
                      onClick={this.copyToClipboard.bind(this)}
                      bsStyle="success"
                    >
                      COPY
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="form-group" id="modalbody">
                  {this.state.alertModal.text}
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              &nbsp;
              <Button
                bsStyle="warning"
                onClick={this.resetInputFields.bind(this)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Grid
          style={{
            minHeight: '100vh',
          }}
        >
          <Form
            onChange={this.handleUpdate.bind(this)}
            ref={(form) => (this.couponGenForm = form)}
          >
            <h3>Coupon Codes</h3>
            <br />
            <Row>
              <Col md={4}>
                <label htmlFor="basic-url">Coupon Category</label>
                <br />
                Customer Service
              </Col>
              <Col md={4}>
                <label htmlFor="basic-url">Coupon Type</label>
                <br />
                Single Use Code
              </Col>
              <Col md={4}>
                <label htmlFor="basic-url">Coupon Quantity</label>
                <br />
                One
              </Col>
            </Row>
            <br />
            <br />
            <Row>
              <Col md={2}>
                <label htmlFor="basic-url">All fields are required</label>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={6}>
                <label htmlFor="basic-url">Search Customer Issue Type</label>
                <FormControl
                  ref="couponCategory"
                  list="coupon-categories"
                  id="coupon-categories-choice"
                  name="coupon-categories-choice"
                  componentClass="input"
                  placeholder="Select an issue type"
                />
                <datalist id="coupon-categories">
                  {this.state.couponCategoriesCS.map((item) => (
                    <option key={item.displayValue} value={item.displayValue} />
                  ))}
                </datalist>
              </Col>
              <Col md={6}>
                <label htmlFor="basic-url">Code Value</label>

                <FormControl
                  componentClass="select"
                  ref="couponValue"
                  id="coupon-values-choice"
                >
                  <option defaultValue="defaultValue" value="value">
                    Select a code value
                  </option>
                  {this.state.couponValuesCS.map((item) => (
                    <option key={item.displayValue} value={item.displayValue}>
                      {item.displayValue}
                    </option>
                  ))}
                </FormControl>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={6}>
                <label htmlFor="basic-url">Coupon Start Date</label>
                <br />

                <DatePicker
                  onChange={this.handleCurrentStartDateChange}
                  value={this.state.currentStartDate}
                />
              </Col>
              <Col md={6}>
                <label htmlFor="basic-url">Coupon End Date</label>
                <br />
                <DatePicker
                  onChange={this.handleCurrentEndDateChange}
                  value={this.state.currentEndDate}
                />
              </Col>
            </Row>
            <br />
            <Row className="text-center">
              <Col md={1}>
                <Button
                  id="generateCodeButton"
                  bsStyle="success"
                  bsSize="large"
                  onClick={this.generateCoupon.bind(this)}
                  disabled={
                    !(
                      this.state.selectedCouponCategory &&
                      this.state.selectedCouponValue &&
                      this.state.currentStartDate &&
                      this.state.currentEndDate
                    )
                  }
                >
                  GENERATE CODE
                </Button>
              </Col>
            </Row>
            {/* </Container> */}
          </Form>
        </Grid>
      </div>
    );
  }
}

export default Coupons;
